module.exports = __webpack_public_path__ + "img/PH.960a66a4.png";